import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/_layout/a')({
  component: () => (
    <div>
      <h1 style={{ marginBottom: '10px', color: '#333', fontSize: '1.5rem' }}>Pathless Layout Child: A</h1>
      <p style={{ color: '#666', fontSize: '14px' }}>
        URL은 /a 이지만 _layout의 레이아웃을 상속받아 렌더링됩니다.
      </p>
    </div>
  ),
});

